import qs from 'qs'
import axios from '@/api/apiClient'
import { deepClone, encryption } from '@/utils/util'

/**
 * 会员api
 */
const api = {
  // 查询参展商产品信息
  releaseList: '/api/product/info/myallproduct',
  // 参展商-参展的展览
  exhibitionlist: '/api/exhibition/info/exhibitor',
  // 主办方-发布的展览
  setExhibitionlist: '/api/exhibition/info/organize',
  /**
   * 名片
   * /member/card 前端页面-相关
   * /member/mycard 我的名片-相关
   * /member/myexchangecard 名片交换-相关
   */
  // 名片列表
  memberCardList: '/api/member/card/list',
  // 名片详情 {unicode}
  memberCardDetail: '/api/member/card/info',
  // 我的名片
  myMemberCard: '/api/member/mycard/info/lang',
  // 更新我的名片信息
  updateMyMemberCard: '/api/member/mycard/lang/update',
  // 我的名片夹列表
  exchangCardList: '/api/member/mycard/list',
  // 名片交换申请列表
  exchangCardApplyList: '/api/member/mycard/exchanglist',
  // 处理交换云展申请
  swapCardDispose: '/api/member/myexchangecard/dispose',
  // 我的名片夹列表
  swapCardApply: '/api/member/myexchangecard/launch',
  // 开始交换云展
  swapCardStart: '/api/member/myexchangecard/start',
  // 交换云展统计
  swapCardCount: '/api/member/mycard/myCardCount',

  /**
   * 修改资料
   */
  // 会员修改邮箱
  putEmail: '/api/member/myinfo/email',
  // 会员修改密码
  putPassword: '/api/member/myinfo/password',
  // 会员修改用户名
  putUserName: '/api/member/myinfo/username',
  // 会员修改基础资料
  putUserInfo: '/api/member/myinfo/detail',

  /**
   * 我的钱包流水(消费, 收入, 充值, 提现)
   */
  // 消费列表
  consume: '/api/member/myaccountflow/consume',
  // 收入列表
  income: '/api/member/myaccountflow/income',
  // 充值列表
  recharge: '/api/member/myaccountflow/recharge',
  // 提现列表
  cashout: '/api/member/myaccountflow/cashout',
  // 查看某条流水
  flowStatus: '/api/member/myaccountflow/recharge',

  /**
   * 我的钱包
   */
  // 查看我的钱包信息
  myaccount: '/api/member/myaccount',
  // 获取可提现余额,提现手续费
  canCashout: '/api/member/myaccount/cashout',
  sendcode: '/api/member/myaccountflow/cashout/sendcode',
  /**
   * 我的收藏
   */
  collectAdd: '/api/member/myfav',
  collectCancel: '/api/member/myfav/del',
  collectList: '/api/member/myfav',

  /**
   * vip会员
   */
  vipConfig: '/api/member/vip/list',
  /**
   * 大数据?hhhh
   */
  companyTab: '/api/member/myinfo/industry',

  // 获取企业员工列表
  employeeList: '/api/member/card/organize',
  // 获取名片详情
  memberCardInfo: '/api/member/card',
}

export default api
/**
 * 公司标签
 * @param {*} param.companyIndustry 感兴趣行业(多个以逗号隔开)
 * @param {*} param.industryId 企业行业ID（二级）
 */
export const putCompanyTab = (param) => {
  return axios.$put(api.companyTab, param)
}
/**
 * 获取vip会员配置信息
 * @param {*} param
 */
export const getVipConfig = () => {
  return axios.$get(`${api.vipConfig}`)
}
/**
 * postAddCollect 新增收藏
 * postCancelCollect 取消收藏
 * @param {Object} param
 * @param {String} param.bizUnicode 对应模块业务编码unicode
 * @param {Number} param.moduleId 模块 1-会员模块,2- 企业模块 ,3-展览模块,4- 会议模块,5- 模型模块,6- 资讯模块,7- 直播模块,8- 海报设计模块,9- 首页模块,10- 产品模块,12 - 3D模块
 */
export const postAddCollect = (param) => {
  return axios.$post(`${api.collectAdd}`, param)
}
export const postCancelCollect = (param) => {
  return axios.$post(`${api.collectCancel}`, param)
}

/**
 * 我的收藏列表
 * @param {*} query.id 1-会员,2- 企业 ,3-展览,4- 会议,5- 模型,6- 资讯,
 7- 直播,8- 海报设计, 10- 产品,12 - 3D,13 - 招标,201-设计师,203-展台搭建工程商
 */
export const getFavList = (query) => {
  return axios.$get(`${api.collectList}/${query.id}${query ? `?${qs.stringify(query)}` : ''}`)
}
// 用不到
// export const getCollectList = (query) => {
//   return axios.$get(
//     `${api.collectList}${query ? `?${qs.stringify(query)}` : ''}`
//   )
// }
export const postUpdateCard = (param) => {
  return axios.$post(`${api.updateMyMemberCard}`, param)
}
export const postSwapCardDispose = (param) => {
  return axios.$post(api.swapCardDispose, param)
}
export const getSwapCardCount = () => {
  return axios.$get(`${api.swapCardCount}`)
}
export const getSwapCardApply = async (memberUnicode) => {
  let res = await axios.$get(`${api.swapCardApply}?memberUnicode=${memberUnicode}`)
  if (res.code === 0) {
    res = await axios.$get(`${api.swapCardStart}?memberUnicode=${memberUnicode}`)
  }
  return res
}
/**
 * 修改会员资料
 * @param {*} param
 * @param {*} param.avatar 修改头像
 * @param {*} param.email 修改邮箱
 * @param {*} param.username 修改用户名（只能修改一次）
 */
export const putUserInfo = (param) => {
  return axios.$put(api.putUserInfo, param)
}
export const putEmail = (param) => {
  return axios.$put(api.putEmail, param)
}
export const putPassword = (params) => {
  const param = deepClone(params)
  // 加密密码
  param.oldpassword = encryption(param.oldpassword)
  param.password = encryption(param.password)
  param.repassword = encryption(param.repassword)
  return axios.$put(api.putPassword, param)
}
export const putUserName = (param) => {
  return axios.$put(api.putUserName, param)
}
// 获取我的名片信息
export const getMyMemberCard = () => {
  return axios.$get(`${api.myMemberCard}`)
}
// 获取我的名片夹列表
export const getMyExchangCardList = (query) => {
  return axios.$get(`${api.exchangCardList}${query ? `?${qs.stringify(query)}` : ''}`)
}
/**
 * 获取名片交换申请列表
 * @param {*} query.
 */
export const getMyExchangCardApplyList = (query) => {
  return axios.$get(`${api.exchangCardApplyList}${query ? `?${qs.stringify(query)}` : ''}`)
}
// 获取名片列表
export const getCardList = (query) => {
  return axios.$get(`${api.memberCardList}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 获取会员名片
export const getMemberCardInfo = async (unicode, query) => {
  return await axios.$get(`${api.memberCardDetail}/${unicode}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 获取产品列表
export const getReleaseList = async (query, interpret) => {
  if (interpret) {
    query.interpret = 1
  }
  const { data } = await axios.$get(`${api.releaseList}${query ? `?${qs.stringify(query)}` : ''}`)
  return data
}
export const getReleaseListNew = async (query, interpret) => {
  if (interpret) {
    query.interpret = 1
  }
  return await axios.$get(`${api.releaseList}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 获取参展商参加的展览
export const getExhibitionlist = async (comunicode, query, interpret) => {
  if (interpret) {
    query.interpret = 1
  }
  const { data } = await axios.$get(`${api.exhibitionlist}/${comunicode}${query ? `?${qs.stringify(query)}` : ''}`)
  return data
}

// 获取参展商参加的展览(返回响应)
export const getExhibitionlistNew = async (query, interpret) => {
  return await axios.$get(`${api.exhibitionlist}/${query.comunicode}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 获取主办方主办的展览
export const getSetExhibitionlist = async (comunicode, query, interpret) => {
  if (interpret) {
    query.interpret = 1
  }
  const { data } = await axios.$get(`${api.setExhibitionlist}/${comunicode}${query ? `?${qs.stringify(query)}` : ''}`)
  return data
}

export const getSetExhibitionlistNew = async (comunicode, query, interpret) => {
  if (interpret) {
    query.interpret = 1
  }
  return await axios.$get(`${api.setExhibitionlist}/${comunicode}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 消费列表
export const getConsume = (query) => {
  return axios.$get(`${api.consume}${query ? `?${qs.stringify(query)}` : ''}`)
}
// 收入列表
export const getIncome = (query) => {
  return axios.$get(`${api.income}${query ? `?${qs.stringify(query)}` : ''}`)
}
// 充值列表
export const getRecharge = (query) => {
  return axios.$get(`${api.recharge}${query ? `?${qs.stringify(query)}` : ''}`)
}
// 提现列表
export const getCashout = (query) => {
  return axios.$get(`${api.cashout}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 充值接口
export const postRecharge = (param) => {
  return axios.$post(`${api.recharge}`, param, {
    headers: { Terminal: window.btoa('pc:chrome,ie9,firefox') },
  })
}

// 是否支付成功
export const getFlowStatus = (flowunicode) => {
  return axios.$get(`${api.flowStatus}/${flowunicode}`)
}

// 获取提现详情
export const getCashoutDetail = (flowunicode) => {
  return axios.$get(`${api.cashout}/${flowunicode}`)
}

// 查看的我账户信息
export const getMyAccount = () => {
  return axios.$get(`${api.myaccount}`)
}

export const getCanCashout = (query) => {
  return axios.$get(`${api.canCashout}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 用户提现-确认提现发送手机验证码
export const sendCode = (param) => {
  return axios.$post(`${api.sendcode}`, param, {
    headers: { Terminal: window.btoa('pc:chrome,ie9,firefox') },
  })
}

// 用户提现
export const setCanCashout = (param) => {
  return axios.$post(`${api.cashout}`, param, {
    headers: { Terminal: window.btoa('pc:chrome,ie9,firefox') },
  })
}

// 获取企业员工列表
export const getEmployeeInfo = (memunicode, query) => {
  return axios.$get(`${api.employeeList}/${memunicode}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * @description: PC端洽谈个人信息接口
 * @param {*} memunicode 员工code
 * @return {*}
 */
export const getMemberInfo = (memunicode, query) => {
  return axios.$get(`${api.memberCardInfo}/${memunicode}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 支付-购买邀约点数套餐
 * transferType 转账类型(0:微信支付 1:对公转账)
 * financeType 支付方式: 111--微信扫码支付(PC都用这个) ； 112--微信APP支付 ； 113--微信小程序支付 ；
 * orderType 订单类型;5:"模型模块";8:"海报设计模块";50:"会员开通";13:"短信"
 * setMealCode 套餐编码
 * totalFee 订单总金额
 * flowunicode 流水唯一编码
 *  openid 小程序支付传入
 */
export const postBuyInvite = (param) => {
  return axios.$post(`/api/member/myaccountflow/buyTextMessageMeal`, param)
}

/**
 * 支付-购买会员套餐
 * 参数同上, code不同
 */
export const postBuyMember = (param) => {
  return axios.$post(`/api/member/myaccountflow/membershipPackageApply`, param)
}
// 点击微信支付, 调查询是否有待支付接口, 如果带支付接口有id, 则跳转详情, 如果没有, 则跳转支付

// 检查是否正在申请并返回申请的公司名称
export const checkApply = async (param) => {
  return await axios.$get(`/api/member/myJoin/checkJoin`, param)
}
